import React from 'react';
import { Monitor, Eye, Lightbulb, Wifi } from 'lucide-react';

const Solutions = () => {
  const solutions = [
    {
      icon: Monitor,
      title: 'Integrated Command and Control Center (ICCC)',
      description: 'The "brain" of any smart ecosystem. Our ICCC consolidates data from disparate sources into a single, unified interface, enabling real-time monitoring and rapid incident response for city administrators and facility managers.',
      image: 'https://images.unsplash.com/photo-1652145595413-0a79398e5888?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjb21tYW5kJTIwY2VudGVyfGVufDB8fHx8MTc3MTcyODk4MXww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Eye,
      title: 'Video Analytics and Face Recognition',
      description: 'Beyond simple surveillance, our AI-driven video solutions provide automated threat detection, crowd management, and secure access control through high-precision facial recognition technology.',
      image: 'https://images.unsplash.com/photo-1644329770639-1a20809b82a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxzbWFydCUyMGJ1aWxkaW5nfGVufDB8fHx8MTc3MTcyODk4NHww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Lightbulb,
      title: 'Smart Lighting',
      description: 'Energy efficiency meets intelligence. Our lighting systems adapt to environmental conditions and occupancy, significantly reducing carbon footprints and operational costs while enhancing public safety.',
      image: 'https://images.unsplash.com/photo-1599580546666-c26f15e00933?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGJ1aWxkaW5nfGVufDB8fHx8MTc3MTcyODk4NHww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Wifi,
      title: 'IoT Solutions',
      description: 'We build robust Internet of Things (IoT) networks that connect sensors and devices across vast infrastructures, ensuring a continuous flow of data to optimize every facet of operational performance.',
      image: 'https://images.unsplash.com/photo-1558449028-b53a39d100fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxzb2xhciUyMGVuZXJneXxlbnwwfHx8fDE3NzE3Mjg5OTZ8MA&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <section id="solutions" className="solutions-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Core Solutions</h2>
          <p className="section-description">
            Comprehensive technology solutions for modern smart ecosystems
          </p>
        </div>

        <div className="solutions-grid">
          {solutions.map((solution, index) => (
            <div key={index} className="solution-card">
              <div className="solution-image-container">
                <img
                  src={solution.image}
                  alt={solution.title}
                  className="solution-image"
                />
                <div className="solution-image-overlay"></div>
              </div>
              <div className="solution-content">
                <div className="solution-icon-container">
                  <solution.icon className="solution-icon" size={28} />
                </div>
                <h3 className="solution-title">{solution.title}</h3>
                <p className="solution-description">{solution.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
